module.exports = __webpack_public_path__ + "img/root00.dbc5f99f.png";